import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface UIState {
  themeMode: "light" | "dark" | "auto";
  sidebarOpen: boolean;
  notice: string | null;
  error: string | null;
}

const initialState: UIState = {
  themeMode: "auto",
  sidebarOpen: true,
  notice: null,
  error: null,
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    setThemeMode: (state, action: PayloadAction<"light" | "dark" | "auto">) => {
      state.themeMode = action.payload;
      localStorage.setItem("theme_mode", action.payload);
    },
    toggleSidebar: (state) => {
      state.sidebarOpen = !state.sidebarOpen;
    },
    setSidebarOpen: (state, action: PayloadAction<boolean>) => {
      state.sidebarOpen = action.payload;
    },
    showNotice: (state, action: PayloadAction<string>) => {
      state.notice = action.payload;
    },
    hideNotice: (state) => {
      state.notice = null;
    },
    showError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
    },
    hideError: (state) => {
      state.error = null;
    },
  },
});

export const {
  setThemeMode,
  toggleSidebar,
  setSidebarOpen,
  showNotice,
  hideNotice,
  showError,
  hideError,
} = uiSlice.actions;

export default uiSlice.reducer;
